(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["klar-desc-wide"] && !Shopify.designMode) return;
  try {
    
class KlarDwExpander extends HTMLElement {
  connectedCallback() {
    const btn = this.querySelector('.klar-dw__btn');
    const content = this.querySelector('.klar-dw__content');
    if (!btn || !content) return;

    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      content.classList.toggle('klar-dw__content--collapsed', expanded);
      content.classList.toggle('klar-dw__content--expanded', !expanded);
    });
  }
}

if (!customElements.get('klar-dw-expander')) {
  customElements.define('klar-dw-expander', KlarDwExpander);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
